module.exports = __webpack_public_path__ + "c57a50b24f96e8df3b3b9eef4ff17826.pdf";